const actionTypes = {
  GET_ISBOTTOM: 'GET_ISBOTTOM'
};
export default actionTypes;